import React, { useContext } from "react";
import MainMenu from "./MainMenu";
import SubMenus from "./SubMenus";
import LightSubMenu from "./LightSubMenu";
import { CustomI18nextContext } from "../../../../contexts/CustomI18nextContext";
import { linkTo } from "../../../Link";

const MobileMenu = ({ menuPage, setMenuPage, latestPosts, siteCountry, t }) => {
  const { lang } = useContext(CustomI18nextContext);

  const zipmexlabsAvailable = ["th_en", "id_en", "au", "en"].includes(lang);
  const zipmexlabsLink = `https://zipmex.com${linkTo(lang, "/zipmexlabs/")}`;

  const MENU_LIST = {
    trade: {
      subMenus: [
        { title: "exchange", to: t("menu.trade.exchange.link") },
        ...(siteCountry === "id"
          ? [{ title: "zipstocks", to: "/trade/zipstocks/" }]
          : []),
        { title: "fees", to: "/fee-schedule/" },
      ],
    },
    earn: {
      subMenus: [
        { title: "zipup", to: "/earn/" },
        { title: "zmt", to: "/zmt/" },
        { title: "zlaunch", to: "/zlaunch/" },
      ],
    },
    ...(siteCountry === "th" && {
      explore: {
        header: { to: "/explore/zipworld/" },
      },
    }),
    campaigns: {
      header: { to: "/campaigns/" },
      subMenus: [{ title: "referAFriend", to: "/earn-referral/" }],
    },
    company: {
      subMenus: [
        { title: "getStarted.aboutUs", to: "/about-us/" },
        {
          title: "getStarted.careers",
          to: "https://zipmex.bamboohr.com/jobs/",
        },
        { title: "getStarted.contactUs", to: "/contact-us/" },
        ...(zipmexlabsAvailable
          ? [{ title: "getStarted.zipmexlabs", to: zipmexlabsLink }]
          : []),
      ],
      additionalSubMenus: [
        { title: "updates.news", to: "/news/" },
        { title: "updates.announcements", to: "/announcements/" },
      ],
    },
    support: {
      header: { to: "/support/" },
      subMenus: [
        { title: "supportCenter.generalFaqs", to: "/support/general-faqs/" },
        {
          title: "supportCenter.gettingStarted",
          to: "/support/getting-started/",
        },
        {
          title: "supportCenter.accountManagement",
          to: "/support/account-management/",
        },
        { title: "supportCenter.trading", to: "/support/trading/" },
        { title: "supportCenter.fiatTransfer", to: "/support/fiat-transfers/" },
        {
          title: "supportCenter.digitalAssetTransfer",
          to: "/support/digital-assets-transfers/",
        },
      ],
    },
    learn: {
      subMenus: [
        { title: "learn", to: "/learn/" },
        { title: "coinInfo", to: "/coin-info/" },
        { title: "glossary", to: "/glossary/" },
      ],
      latestPosts,
    },
  };

  switch (menuPage) {
    case null:
      return (
        <MainMenu setMenuPage={setMenuPage} t={t} siteCountry={siteCountry} />
      );
    case "company":
      return (
        <LightSubMenu
          setMenuPage={setMenuPage}
          mainMenu={menuPage}
          contents={MENU_LIST[menuPage]}
        />
      );
    case "support":
      return (
        <LightSubMenu
          setMenuPage={setMenuPage}
          mainMenu={menuPage}
          contents={MENU_LIST[menuPage]}
        />
      );
    case "explore":
      return (
        <LightSubMenu
          setMenuPage={setMenuPage}
          mainMenu={menuPage}
          contents={MENU_LIST[menuPage]}
        />
      );
    default:
      return (
        <SubMenus
          setMenuPage={setMenuPage}
          mainMenu={menuPage}
          contents={MENU_LIST[menuPage]}
        />
      );
  }
};

export default MobileMenu;
